import { useTranslation } from 'react-i18next'

import { Text } from '@reveni-io/reveni-ui'

import * as Styles from './styles'

const NoReturnPortalsFound = () => {
  const { t } = useTranslation()

  return (
    <Styles.NoResultsContainer>
      <Text type="titleS" color="#A1A1A1">
        {t('No hay resultados para esta búsqueda')}
      </Text>
    </Styles.NoResultsContainer>
  )
}

export default NoReturnPortalsFound
